/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoadingCapabilitiesAvailability } from './LoadingCapabilitiesAvailability';
import {
    LoadingCapabilitiesAvailabilityFromJSON,
    LoadingCapabilitiesAvailabilityFromJSONTyped,
    LoadingCapabilitiesAvailabilityToJSON,
    LoadingCapabilitiesAvailabilityToJSONTyped,
} from './LoadingCapabilitiesAvailability';
import type { LocationContext } from './LocationContext';
import {
    LocationContextFromJSON,
    LocationContextFromJSONTyped,
    LocationContextToJSON,
    LocationContextToJSONTyped,
} from './LocationContext';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface SetAddressAndContactRequest
 */
export interface SetAddressAndContactRequest {
    /**
     * 
     * @type {string}
     * @memberof SetAddressAndContactRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {LocationContext}
     * @memberof SetAddressAndContactRequest
     */
    context: LocationContext;
    /**
     * 
     * @type {Location}
     * @memberof SetAddressAndContactRequest
     */
    location: Location;
    /**
     * 
     * @type {Contact}
     * @memberof SetAddressAndContactRequest
     */
    contact: Contact;
    /**
     * Carrier-facing reference. For an Amazon distribution-warehouse delivery, supply amazonReferenceId and amazonShipmentId instead - the server packs them into this reference. If both routes are supplied, they must match
     * @type {string}
     * @memberof SetAddressAndContactRequest
     */
    referenceNumber?: string;
    /**
     * Amazon Reference ID. Only valid with context 'delivery' when the location is an Amazon distribution warehouse; required then, along with amazonShipmentId
     * @type {string}
     * @memberof SetAddressAndContactRequest
     */
    amazonReferenceId?: string;
    /**
     * Amazon Shipment ID. Only valid with context 'delivery' when the location is an Amazon distribution warehouse; required then, along with amazonReferenceId
     * @type {string}
     * @memberof SetAddressAndContactRequest
     */
    amazonShipmentId?: string;
    /**
     * Whether this location should be a favourite in the address book. Omit to leave an existing location's favourite flag alone — only send a value when it reflects a choice the customer actually made.
     * @type {boolean}
     * @memberof SetAddressAndContactRequest
     */
    markLocationAsFavourite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetAddressAndContactRequest
     */
    markLocationAsDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof SetAddressAndContactRequest
     */
    boothNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SetAddressAndContactRequest
     */
    deadline?: string;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof SetAddressAndContactRequest
     */
    pickupLocationHasDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof SetAddressAndContactRequest
     */
    pickupLocationHasForklift?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof SetAddressAndContactRequest
     */
    deliveryLocationHasDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof SetAddressAndContactRequest
     */
    deliveryLocationHasForklift?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {boolean}
     * @memberof SetAddressAndContactRequest
     */
    skipValidation?: boolean;
}



/**
 * Check if a given object implements the SetAddressAndContactRequest interface.
 */
export function instanceOfSetAddressAndContactRequest(value: object): value is SetAddressAndContactRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('context' in value) || value['context'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('contact' in value) || value['contact'] === undefined) return false;
    if (!('markLocationAsDefault' in value) || value['markLocationAsDefault'] === undefined) return false;
    if (!('boothNumber' in value) || value['boothNumber'] === undefined) return false;
    return true;
}

export function SetAddressAndContactRequestFromJSON(json: any): SetAddressAndContactRequest {
    return SetAddressAndContactRequestFromJSONTyped(json, false);
}

export function SetAddressAndContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetAddressAndContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'context': LocationContextFromJSON(json['context']),
        'location': LocationFromJSON(json['location']),
        'contact': ContactFromJSON(json['contact']),
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'amazonReferenceId': json['amazonReferenceId'] == null ? undefined : json['amazonReferenceId'],
        'amazonShipmentId': json['amazonShipmentId'] == null ? undefined : json['amazonShipmentId'],
        'markLocationAsFavourite': json['markLocationAsFavourite'] == null ? undefined : json['markLocationAsFavourite'],
        'markLocationAsDefault': json['markLocationAsDefault'],
        'boothNumber': json['boothNumber'],
        'deadline': json['deadline'] == null ? undefined : json['deadline'],
        'pickupLocationHasDock': json['pickupLocationHasDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasDock']),
        'pickupLocationHasForklift': json['pickupLocationHasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasForklift']),
        'deliveryLocationHasDock': json['deliveryLocationHasDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': json['deliveryLocationHasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasForklift']),
        'skipValidation': json['skipValidation'] == null ? undefined : json['skipValidation'],
    };
}

  export function SetAddressAndContactRequestToJSON(json: any): SetAddressAndContactRequest {
      return SetAddressAndContactRequestToJSONTyped(json, false);
  }

  export function SetAddressAndContactRequestToJSONTyped(value?: SetAddressAndContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'context': LocationContextToJSON(value['context']),
        'location': LocationToJSON(value['location']),
        'contact': ContactToJSON(value['contact']),
        'referenceNumber': value['referenceNumber'],
        'amazonReferenceId': value['amazonReferenceId'],
        'amazonShipmentId': value['amazonShipmentId'],
        'markLocationAsFavourite': value['markLocationAsFavourite'],
        'markLocationAsDefault': value['markLocationAsDefault'],
        'boothNumber': value['boothNumber'],
        'deadline': value['deadline'],
        'pickupLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasDock']),
        'pickupLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasForklift']),
        'deliveryLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasForklift']),
        'skipValidation': value['skipValidation'],
    };
}

